export default "__VITE_ASSET__4c1a65bb__"